var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "none",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M36 0H0v23.992h36V-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M36 17.994H0v3.749h36v-3.75ZM21 11.996l1.5-2.598h-3L18 6.801l-1.5 2.597h-3l1.5 2.598-1.5 2.597h3L18 17.19l1.5-2.597h3L21 11.996Zm.071-1.773-.547.948-.548-.948h1.095Zm-1.024 1.773-1.023 1.772h-2.048l-1.023-1.772 1.023-1.773h2.048l1.023 1.773ZM18 8.45l.547.947h-1.094L18 8.451Zm-3.071 1.772h1.095l-.548.948-.547-.948Zm0 3.545.547-.948.548.948h-1.095ZM18 15.541l-.547-.948h1.094L18 15.54Zm2.524-2.72.547.947h-1.095l.548-.948ZM36 2.249H0v3.749h36v-3.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v23.995H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.41b2a5de73f7c150e589d8b6b5a220e6.svg";
export { ForwardRef as ReactComponent };